/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, Suspense, useRef } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { fetchDataTarget } from "../../helpers/target.ts";
import { fetchOverview } from "../../helpers/overview.ts";
import FilterBar from "../Filter/index.jsx";
import { getSavedLayouts } from "../../api/static/staticFiles.ts";
import { useSelector } from "react-redux";

const ResponsiveGridLayout = WidthProvider(Responsive);

const Dashboard = () => {
  const { filter } = useSelector((state) => state.filter);
  const {
    selectedStart,
    selectedEnd,
    compareStart,
    compareEnd,
    selectedLocationStore,
    weekDaySelected,
  } = filter;
  //
  const [loading, setLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [layouts, setLayouts] = useState([]);
  //
  const [mounted, setMounted] = useState(false);
  //
  const { listKpis2 } = useSelector((state) => state.filter);
  const payloadCommon = () => {
    return {
      kpis: listKpis2,
      startDate: selectedStart,
      endDate: selectedEnd,
      compareStartDate: compareStart,
      compareEndDate: compareEnd,
      storeCodes: selectedLocationStore,
      days: weekDaySelected,
    };
  };
  const lastParams = useRef(null);
  const debounceTimer = useRef(null);

  useEffect(() => {

      if (!mounted) {
        setMounted(true);
        return;
      }
  
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(async () => {
        try {
          const params = {
            ...payloadCommon(),
            groupByMetricKey: true,
            comparisonYKPIMetricKey: "sls",
          };
  
          if (JSON.stringify(params) === JSON.stringify(lastParams.current)) {
            console.log("Skipping fetchOverview: Params unchanged");
            return;
          }
  
          lastParams.current = params;
          setLoading(true);
         // await fetchOverview(params);
          const promises = [fetchOverview(params)];
  
          if (
            listKpis2.length > 0 &&
            listKpis2.includes("sls") &&
            listKpis2.includes("st")
          ) {
            promises.push(
              fetchDataTarget({
                ...payloadCommon(),
                client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
                client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
                kpiTypes: ["sls", "st"],
                frequency: "daily",
              })
            );
          }
            // await fetchDataTarget({
            //   ...payloadCommon(),
            //   client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
            //   client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
            //   kpiTypes: ["sls", "st"],
            //   frequency: "daily",
            // });
            await Promise.all(promises); 
          setLoading(false);
        } catch (error) {
          console.error(error);
        }
      }, 500); // Debounce delay
  
      return () => {
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
      };
    }, [filter]);

  useEffect(() => {
    const fetchDataAndHandleErrors = async () => {
      // setLoading(true);
      try {
        const pageName = "operation";
        const layoutPage = await fetchData(pageName);
        console.log("layoutPage", layoutPage);
        setDataList(layoutPage);
        //
        const defaultLayouts = layoutPage?.map((section) => section.layouts);
        setLayouts(defaultLayouts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchDataAndHandleErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchData = async (pageName) => {
    // setLoading(true);
    try {
      const response = await getSavedLayouts(pageName);
      setLoading(false);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      throw error;
    }
  };

  const renderHandler = () => {
    return (
      <div>
        <FilterBar/>
        <div className={`page-wrapper dashboard-wrapper ${loading ? "loading-active" : "loading-unactive"}`}>
           <div className="loader-content">
            <div id="global-loader">
              <div className="whirly-loader"></div>
            </div>
          </div>
        </div>
       
        <div
          className={`page-wrapper dashboard-wrapper ${
            !loading ? "loading-active" : "loading-unactive"
          }`}
        >
          <div className="dashboard-content">
            {Array.isArray(dataList) &&
              dataList?.map((items, index) => (
                <div key={index} className="main-section">
                  <div className="dashboard-items">
                    <ResponsiveGridLayout
                      className="layout"
                      layouts={{ lg: layouts[index] || [] }}
                      breakpoints={{
                        lg: 900,
                        md: 768,
                        sm: 568,
                        xs: 480,
                        xxs: 0,
                      }}
                      cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                      isDraggable={false}
                      isResizable={false}
                    >
                      {items.components.map((item) => {
                        console.log("item operation", item.name);
                        const Component = React.lazy(() =>
                          import(`../customComponents/${item.name}`).catch(
                            () => {
                              return import(`../customComponents/NotFound.jsx`);
                            }
                          )
                        );

                        return Component ? (
                          <div key={item.layoutId}>
                            <Suspense
                              style={{ width: "inherit", height: "inherit" }}
                            >
                              {/* <Component /> */}
                              <Component item={item} />
                            </Suspense>
                          </div>
                        ) : (
                          <div key={item.layoutId}>
                            <div
                              style={{ width: "inherit", height: "inherit" }}
                            >
                              Component {item.name} not found.
                            </div>
                          </div>
                        );
                      })}
                    </ResponsiveGridLayout>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };

  return <>{renderHandler()}</>;
};

export default Dashboard;
